import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class CopyWorksheetDto {
  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date: Date;
}
